module.exports = __webpack_public_path__ + "static/img/bg-es.c922d1ff.png";